export * from './actionparticipants/actionparticipants-edit.component';
export * from './actionparticipants/actionparticipants.component';
export * from './actionparticipants/actionparticipants-plugin.service';

export * from './add/add-plugin.component';

export * from './associateequipment/associateequipment-edit.component';
export * from './associateequipment/associateequipment-plugin-factory.service';
export * from './associateequipment/associateequipment-plugin.service';
export * from './associateequipment/associateequipment-select.component';
export * from './associateequipment/associateequipment.component';

export * from './attachements/attachement-delete.component';
export * from './attachements/attachement-upload.component';
export * from './attachements/attachements-plugin.service';
export * from './attachements/attachements.component';
export * from './attachements/attachment-plugin-factory.service';

export * from './barredepinceslockingcheck/lockingCheck-edit.component';
export * from './barredepinceslockingcheck/lockingCheck.component';
export * from './barredepinceslockingcheck/lockingCheck-plugin.service';

export * from './boxes/boxes-edit.component';
export * from './boxes/boxes.component';
export * from './boxes/boxes-plugin.service';

export * from './comment/comment-edit.component';
export * from './comment/comment.component';
export * from './comment/comment-plugin.service';
export * from './comment/comment-plugin-factory.plugin';
export * from './comment/commenttype.pipe';
export * from './comment/icon.pipe';
export * from './comment/iconType.pipe';
export * from './comment/importance.pipe';

export * from './actionscompleted/actions-completed-edit.component';
export * from './actionscompleted/actions-completed.component';
export * from './actionscompleted/actions-completed-plugin.service';

export * from './reportadvise/report-advise-edit.component';
export * from './reportadvise/report-advise.component';
export * from './reportadvise/report-advise-plugin.service';

export * from './assistance/assistance-edit.component';
export * from './assistance/assistance.component';
export * from './assistance/assistance-plugin.service';
export * from './assistance/assistance-action.pipe';

export * from './contact/contact-edit.component';
export * from './contact/contact.component';
export * from './contact/contact-plugin.service';
export * from './contact/contact-plugin-factory.service';

export * from './counter/counter-edit.component';
export * from './counter/counter.component';
export * from './counter/counter-plugin.service';

export * from './counterpressurecylinder/counterpressurecylinder-edit.component';
export * from './counterpressurecylinder/counterpressurecylinder.component';
export * from './counterpressurecylinder/counterpressurecylinder-plugin.service';

export * from './customerremark/customerremark-edit.component';
export * from './customerremark/customerremark.component';
export * from './customerremark/customerremark-plugin-factory.service';
export * from './customerremark/customerremark-plugin.service';
export * from './customerremark/customerremarktype.pipe';

export * from './customerselector/customerselector-edit.component';
export * from './customerselector/customerselector.component';
export * from './customerselector/customerselector-plugin.service';
export * from './customerselector/customerselector-plugin-factory.service';
export * from './customerselector/languages.pipe';

export * from './cycles/cycles-edit.component';
export * from './cycles/cycles.component';
export * from './cycles/cycles-plugin.service';

export * from './cylindricalparallelism/cylindricalparallelism-edit.component';
export * from './cylindricalparallelism/cylindricalparallelism.component';
export * from './cylindricalparallelism/cylindricalparallelism-plugin.service';

export * from './date/date-edit.component';
export * from './date/date.component';
export * from './date/date-plugin.service';

export * from './discussion/discussion-edit.component';
export * from './discussion/discussion.component';
export * from './discussion/discussion-plugin.service';
export * from './discussion/discussioncommenttype.pipe';
export * from './discussion/person-name.pipe';

export * from './executivesummary/executivesummary-edit.component';
export * from './executivesummary/executivesummary.component';
export * from './executivesummary/executivesummary-plugin.service';

export * from './filemanager/create-folder.component';
export * from './filemanager/filemanager-edit.component';
export * from './filemanager/filemanager.component';
export * from './filemanager/filemanager-plugin.service';

export * from './files/file-edit.component';
export * from './files/file-upload.component';
export * from './files/files.component';
export * from './files/photo-annotation.component';
export * from './files/photo-edit.component';
export * from './files/files-plugin-factory.service';
export * from './files/files-plugin.service';
export * from './files/filetotype.pipe';

export * from './filesandsuggestions/fileandsuggestion-edit-suggestion.component';
export * from './filesandsuggestions/fileandsuggestion-edit.component';
export * from './filesandsuggestions/fileandsuggestion-upload.component';
export * from './filesandsuggestions/filesandsuggestions.component';
export * from './filesandsuggestions/filesandsuggestions-plugin.service';
export * from './filesandsuggestions/fileandsuggestiontotype.pipe';

export * from './inspectionInfo/inspectionInfo-edit.component';
export * from './inspectionInfo/inspectionInfo.component';
export * from './inspectionInfo/inspectionInfo-plugin-factory.service';
export * from './inspectionInfo/inspectionInfo-plugin.service';
export * from './inspectionInfo/inspectiontype.pipe';

export * from './job-analysis/job-analysis-edit.component';
export * from './job-analysis/job-analysis.component';
export * from './job-analysis/job-analysis-plugin.service';

export * from './machineselector/categories-edit.component';
export * from './machineselector/machineselector-edit.component';
export * from './machineselector/machineselector.component';
export * from './machineselector/machineselector-plugin-factory.service';
export * from './machineselector/machineselector-plugin.service';

export * from './marketing/marketing-edit.component';
export * from './marketing/marketing.component';
export * from './marketing/marketing-plugin.service';

export * from './observationsandrecommandations/add-observation.component';
export * from './observationsandrecommandations/edit-observation.component';
export * from './observationsandrecommandations/observationsandrecommandations-edit.component';
export * from './observationsandrecommandations/observationsandrecommandations.component';
export * from './observationsandrecommandations/observationandrecommandations-plugin-factory.service';
export * from './observationsandrecommandations/observationsandrecommandations-plugin.service';
export * from './observationsandrecommandations/priorities.pipe';
export * from './observationsandrecommandations/responsibles.pipe';

export * from './optimisationmachineselector/optimisationmachineselector-edit.component';
export * from './optimisationmachineselector/optimisationmachineselector.component';
export * from './optimisationmachineselector/optimisationmachineselector-plugin-factory.service';
export * from './optimisationmachineselector/optimizationmachineselector-plugin.service';

export * from './participants/participants-add.component';
export * from './participants/participants-edit.component';
export * from './participants/participants.component';
export * from './participants/participants-plugin.service';

export * from './parts/parts-edit.component';
export * from './parts/parts.component';
export * from './parts/partsFilter.pipe';
export * from './parts/partsview-modal.component';
export * from './parts/parts-add.component';
export * from './parts/parts-plugin-factory.service';
export * from './parts/parts-plugin.service';
export * from './parts/part';

export * from './peripheralInfo/peripheralinfo-edit.component';
export * from './peripheralInfo/peripheralinfo.component';
export * from './peripheralInfo/peripheralinfo-plugin-factory.service';
export * from './peripheralInfo/peripheralinfo-plugin.service';

export * from './recommendedparts/recommendedparts-edit.component';
export * from './recommendedparts/recommendedparts.component';
export * from './recommendedparts/recommendedparts-plugin.service';
export * from './recommendedparts/currency.pipe';

export * from './repairdays/repairdays-edit.component';
export * from './repairdays/repairdays.component';
export * from './repairdays/repairdays-plugin.service';

export * from './response/responseboolean-edit.component';
export * from './response/responseboolean.component';
export * from './response/responsedate-edit.component';
export * from './response/responsedate.component';
export * from './response/responsenumber-edit.component';
export * from './response/responsenumber.component';
export * from './response/response-plugin.service';

export * from './softwareinfo/softwareinfo-edit.component';
export * from './softwareinfo/softwareinfo.component';
export * from './softwareinfo/softwareinfo-plugin.service';

export * from './spolocking/spo-locking-edit.component';
export * from './spolocking/spo-locking.component';
export * from './spolocking/spo-locking-plugin.service';

export * from './states/states-edit.component';
export * from './states/states.component';
export * from './states/states-plugin.service';
export * from './states/impact.model';
export * from './states/states-plugin-factory.plugin';
export * from './states/states.pipe';
export * from './states/actions.pipe';
export * from './states/statepriority.pipe';

export * from './timecounter/timecounter-edit.component';
export * from './timecounter/timecounter.component';
export * from './timecounter/timecouner-plugin-factory.service';
export * from './timecounter/timecounter-plugin.service';

export * from './timesheet/timesheet-edit.component';
export * from './timesheet/timesheet.component';
export * from './timesheet/timesheet-plugin.service';

export * from './timetorepair/timetorepair-edit.component';
export * from './timetorepair/timetorepair.component';
export * from './timetorepair/timetorepair-plugin.service';
export * from './timetorepair/reparator.pipe';

export * from './totaltimetorepair/totaltimetorepair-edit.component';
export * from './totaltimetorepair/totaltimetorepair.component';
export * from './totaltimetorepair/totaltimetorepair-plugin.service';

export * from './trainingproposals/trainingproposals-edit.component';
export * from './trainingproposals/trainingproposals.component';
export * from './trainingproposals/trainingproposals-plugin.service';
export * from './trainingproposals/course.pipe';
export * from './trainingproposals/moment.pipe';
export * from './trainingproposals/trainer.pipe';

///
///installation plugins
///

export * from './installation/anilox/anilox-edit.component';
export * from './installation/anilox/anilox.component';
export * from './installation/anilox/anilox.service';

export * from './installation/base-installation/edit-view.component';
export * from './installation/base-installation/view.component';
export * from './installation/base-installation/edit-modal-footer/edit-modal-footer.component';
export * from './installation/base-installation/edit-modal-header/edit-modal-header.component';
export * from './installation/base-installation/preview-validation-messages/preview-validation-messages.component';
export * from './installation/base-installation/dynamic.directive';

export * from './installation/bobstattendees/bobst-attendees-edit.component';
export * from './installation/bobstattendees/bobst-attendees.component';
export * from './installation/bobstattendees/bobst-attendees.service';

export * from './installation/bobstcontact/bobst-contact-edit.component';
export * from './installation/bobstcontact/bobst-contact.component';
export * from './installation/bobstcontact/bobst-contact-plugin-factory.service';
export * from './installation/bobstcontact/bobst-contact.service';
export * from './installation/bobstcontact/function.pipe';
export * from './installation/bobstcontact/ownerType.pipe';

export * from './installation/checked/checked-edit.component';
export * from './installation/checked/checked.component';
export * from './installation/checked/checked.service';
export * from './installation/checked/checked-plugin-factory.plugin';
export * from './installation/checked/status.pipe';

export * from './installation/customerattendees/customer-attendees-edit.component';
export * from './installation/customerattendees/customer-attendees.component';
export * from './installation/customerattendees/customer-attendees.service';

export * from './installation/customercomments/customer-comments-edit.component';
export * from './installation/customercomments/customer-comments.component';
export * from './installation/customercomments/customer-comments.service';
export * from './installation/customercomments/customer-comment-from.pipe';

export * from './installation/customercontact/customer-contact-edit.component';
export * from './installation/customercontact/customer-contact.component';
export * from './installation/customercontact/customer-contact.service';
export * from './installation/customercontact/customer-contact-plugin-factory.plugin';

export * from './installation/customerinfo/customer-info-edit.component';
export * from './installation/customerinfo/customer-info.component';
export * from './installation/customerinfo/customer-info-plugin-factory.service';
export * from './installation/customerinfo/customer-info.service';

export * from './installation/dimension/dimension-edit.component';
export * from './installation/dimension/dimension.component';
export * from './installation/dimension/dimension.service';
export * from './installation/dimension/units.pipe';

export * from './installation/distance/distance-edit.component';
export * from './installation/distance/distance.component';
export * from './installation/distance/distance.service';
export * from './installation/distance/distance.pipe';

export * from './installation/duration/duration-edit.component';
export * from './installation/duration/duration.component';
export * from './installation/duration/duration.service';
export * from './installation/duration/timeunits.pipe';

export * from './installation/equipmentinfo/equipment-info-edit.component';
export * from './installation/equipmentinfo/equipment-info.component';
export * from './installation/equipmentinfo/equipment-info-plugin-factory.service';
export * from './installation/equipmentinfo/equipment-info.service';
export * from './installation/equipmentinfo/supplier.pipe';

export * from './installation/freetext/free-text-edit.component';
export * from './installation/freetext/free-text.component';
export * from './installation/freetext/free-text.service';

export * from './installation/groundlevel/ground-level-edit.component';
export * from './installation/groundlevel/ground-level.component';
export * from './installation/groundlevel/ground-level.service';
export * from './installation/groundlevel/leveltype.pipe';

export * from './installation/incoterms/incoterms-edit.component';
export * from './installation/incoterms/incoterms.component';
export * from './installation/incoterms/incoterms.service';
export * from './installation/incoterms/incoterms.pipe';

export * from './installation/installationcomments/installation-comments-edit.component';
export * from './installation/installationcomments/installation-comments.component';
export * from './installation/installationcomments/installation-comments.service';
export * from './installation/installationcomments/commentto.pipe';

export * from './installation/installationdate/installation-date-edit.component';
export * from './installation/installationdate/installation-date.component';
export * from './installation/installationdate/installation-date.service';

export * from './installation/installationinspectioninfo/installation-inspection-info-edit.component';
export * from './installation/installationinspectioninfo/installation-inspection-info.component';
export * from './installation/installationinspectioninfo/installation-inspection-info-plugin-factory.service';
export * from './installation/installationinspectioninfo/installation-inspection-info.service';
export * from './installation/installationinspectioninfo/subType.pipe';

export * from './installation/jobproduced/job-produced-edit.component';
export * from './installation/jobproduced/job-produced.component';
export * from './installation/jobproduced/job-produced.service';
export * from './installation/jobproduced/joblabel.pipe';

export * from './installation/lubricant/lubricant-edit.component';
export * from './installation/lubricant/lubricant.component';
export * from './installation/lubricant/lubricant.service';

export * from './installation/partybccbsa/party-bcc-bsa-edit.component';
export * from './installation/partybccbsa/party-bcc-bsa.component';
export * from './installation/partybccbsa/party-bcc-bsa.service';

export * from './installation/preparationneeded/preparation-needed-edit.component';
export * from './installation/preparationneeded/preparation-needed.component';
export * from './installation/preparationneeded/preparation-needed.service';
export * from './installation/preparationneeded/preparation.pipe';

export * from './installation/received/received-edit.component';
export * from './installation/received/received.component';
export * from './installation/received/received.service';
export * from './installation/received/document-type.pipe';
export * from './installation/received/status.pipe';
export * from './installation/received/received-plugin-factory.plugin';

export * from './installation/roadsurface/road-surface-edit.component';
export * from './installation/roadsurface/road-surface.component';
export * from './installation/roadsurface/road-surface.service';
export * from './installation/roadsurface/surfacetype.pipe';

export * from './installation/signature/signature-edit.component';
export * from './installation/signature/signature.component';
export * from './installation/signature/signature.service';
export * from './installation/signature/signaturetype.pipe';

export * from './installation/staff/staff-edit.component';
export * from './installation/staff/staff.component';
export * from './installation/staff/staff.service';
export * from './installation/staff/stafftype.pipe';

export * from './installation/status/status-edit.component';
export * from './installation/status/status.component';
export * from './installation/status/status.service';
export * from './installation/status/statustype.pipe';

export * from './installation/trainingprovided/training-provided-edit.component';
export * from './installation/trainingprovided/training-provided.component';
export * from './installation/trainingprovided/training-provided.service';

export * from './installation/voltage/voltage-edit.component';
export * from './installation/voltage/voltage.component';
export * from './installation/voltage/voltage.service';
export * from './installation/voltage/voltage-plugin-factory.plugin';

export * from './installation/weight/weight-edit.component';
export * from './installation/weight/weight.component';
export * from './installation/weight/weight.service';
export * from './installation/weight/units.pipe';

export * from './installation/yesno/yes-no-edit.component';
export * from './installation/yesno/yes-no.component';
export * from './installation/yesno/yes-no.service';
export * from './installation/yesno/yesnostatus.pipe';

export * from './installation/executivesummary/executivesummary-edit.component';
export * from './installation/executivesummary/executivesummary.component';
export * from './installation/executivesummary/executivesummary-plugin.service';

export * from './installation/formfile/formfile-edit.component';
export * from './installation/formfile/formfile.component';
export * from './installation/formfile/formfile.service';

export * from './installation/observation/add-observation.component';
export * from './installation/observation/edit-observation.component';
export * from './installation/observation/observationandrecommendations-plugin-factory.service';
export * from './installation/observation/observationsandrecommandations-edit.component';
export * from './installation/observation/observationsandrecommandations-plugin.service';
export * from './installation/observation/observationsandrecommendations.component';
export * from './installation/observation/priorities.pipe';
export * from './installation/observation/responsibles.pipe';

export * from './interventiontasks/interventiontasks-edit.component';
export * from './interventiontasks/interventiontasks.component';
export * from './interventiontasks/interventiontasks-plugin.service';

export * from './upgrades/upgrades-edit.component';
export * from './upgrades/upgrades.component';
export * from './upgrades/upgrades-plugin.service';

export * from './obsolescences/obsolescences-edit.component';
export * from './obsolescences/obsolescences.component';
export * from './obsolescences/obsolescences-plugin.service';

export * from './spotrain/spo-train-edit.component';
export * from './spotrain/spo-train.component';
export * from './spotrain/spo-train-plugin.service';

export * from './machinesafety/machine-safety-edit.component';
export * from './machinesafety/machine-safety.component';
export * from './machinesafety/machine-safety.service';
export * from './machinesafety/yesno.pipe';

export * from './score/score-edit.component';
export * from './score/score.component';
export * from './score/score.service';

export * from './actions/actions-edit.component';
export * from './actions/actions.component';
export * from './actions/actions.service';

export * from './effects/effects-edit.component';
export * from './effects/effects.component';
export * from './effects/effects.service';

export * from './inherentrisk/inherent-risk-edit.component';
export * from './inherentrisk/inherent-risk.component';
export * from './inherentrisk/inherent-risk.service';
export * from './inherentrisk/impact.pipe';
